import templateUrl from 'emun.salesrep/dashboard-totals-status-table.htm';
import basicController from "servicestack/basic.controller.properties";

class DashboardTotalsStatusTableController {
	constructor($window, $rootScope, retailerPrompt, createAutoQuery, utils) {
		let $ctrl = this;
		basicController($ctrl);
		$ctrl.utils = utils;
		var context = $ctrl.context || 'rep';
    var queryCriteria = '';

		var filter = "RepId";
		var repGroupFilter = "";
		if (context === 'vendor') {
			filter = 'VendorId';
		} else if (context === 'subrep') {
			filter = 'SubRepId';
		} else if (context == 'executive') {
			filter = "";
    }
    if ($ctrl.insideSales === 'true') {
      queryCriteria = '&IsInsideSales=true';
		}
		if ($ctrl.repGroup) {
			if ($ctrl.repGroup !== 'ALL') {
				repGroupFilter = '&RepGroupName=' + $ctrl.repGroup;
			}
		}
		if (filter != "") {
			filter = "&" + filter + "=" + $ctrl.rep.id
		} else {
			filter = "&";
    }
		//console.info('date r: ' + $ctrl.dateRange + ' : title: ' + $ctrl.title);
		var dateRange = $ctrl.dateRange || "YTD";
		this.statuses = createAutoQuery({
			url: 'QuerySalesDailyStatusTotals.json?Fields=ERPStatus&Sum=OrderTotal&Sum=OrderTotal,OrderCount' + filter + repGroupFilter + '&GroupBy=ERPStatus',
			orderBy: 'ERPStatus',
			autoLoad: true,
			pageSize: 50
		});
	}
}

let DashboardTotalsStatusTable = {
	bindings: {
		repGroup: '@',
		rep: '<',
		context: '@',
		dateRange: '@',
    title: '@',
    insideSales: '@'
	},
  controller: DashboardTotalsStatusTableController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
}


export default DashboardTotalsStatusTable;